import { Location, Params, useLocation, useParams } from "react-router-dom";

const useCurrentPath = () => {
    const location = useLocation();
    const params = useParams();

    const getRoutePath = (location: Location, params: Readonly<Params<string>>) => {
        const { pathname } = location;

        if (!Object.keys(params).length) {
            return pathname;
        }

        let path = pathname;
        Object.entries(params).forEach(([paramName, paramValue]) => {
            if (paramValue) {
                path =
                    paramName === "*" ? path.replace(paramValue, paramName) : path.replace(paramValue, `:${paramName}`);
            }
        });

        return path;
    };

    return getRoutePath(location, params);
};

export default useCurrentPath;
